const actions = {
  CALENDAR_VIEW: 'CALENDAR_VIEW',
  changeView: view => ({
    type: actions.CALENDAR_VIEW,
    view
  }),
  CALENDAR_EVENTS: 'CALENDAR_EVENTS',
  changeEvents: events => ({
    type: actions.CALENDAR_EVENTS,
    events
  }),
  CHANGE_SELECTED_DATE: 'CHANGE_SELECTED_DATE',
  changeSelectedDAte: selectedDate => ({
    type: actions.CHANGE_SELECTED_DATE,
    selectedDate
  }),
  ON_SELECT_DATE: 'ON_SELECT_DATE',
  onSelectData: (selectedData, modalVisible) => ({
    type: actions.ON_SELECT_DATE,
    selectedData,
    modalVisible
  }),
  GET_PROPERTY_VIEWING_DATA: 'GET_PROPERTY_VIEWING_DATA',
  getPropertyViewingData: () => ({
    type: actions.GET_PROPERTY_VIEWING_DATA,
  }),
  SET_PROPERTY_VIEWING_DATA: 'SET_PROPERTY_VIEWING_DATA',
  setPropertyViewingData: events => ({
    type: actions.SET_PROPERTY_VIEWING_DATA,
    events
  }),
  CONFIRM_PROPERTY_VIEWING: 'CONFIRM_PROPERTY_VIEWING',
  confirmPropertyViewing: payload => ({
    type: actions.CONFIRM_PROPERTY_VIEWING,
    payload
  }),
  CONFIRM_RESCHEDULED_PROPERTY_VIEWING: 'CONFIRM_RESCHEDULED_PROPERTY_VIEWING',
  confirmRescheduledPropertyViewing: payload => ({
    type: actions.CONFIRM_RESCHEDULED_PROPERTY_VIEWING,
    payload
  }),
  DO_LANDLORD_RESCHEDULE: 'DO_LANDLORD_RESCHEDULE',
  doLandlordReschedule: payload => ({
    type: actions.DO_LANDLORD_RESCHEDULE,
    payload
  }),
  DO_LANDLORD_CANCEL: 'DO_LANDLORD_CANCEL',
  landlordCancelBooking: payload => ({
    type: actions.DO_LANDLORD_CANCEL,
    payload
  }),
};
export default actions;



// WEBPACK FOOTER //
// ./src/redux/calendar/actions.js